
<template>
  <zm-modal
    ref="modal"
    @ok="handleSubmit"
    :title="title"
    :visible="visible"
    size="middle"
    @cancel="open(false)"
  >
    <div slot="modalBody">
      <a-form :form="form">
        <a-row>
          <zm-label title="产品信息" class="info_label" />
          <!-- <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="产品编号" hasFeedback>
              <a-input
                placeholder="请输入产品编号"
                id="number"
                autocomplete="off"
                :allowClear="true"
                :disabled="!isEdit"
                v-decorator="['number', { rules: [{ required: true, message: '请输入产品编号！' }] }]"
              />
            </a-form-item>
          </a-col> -->
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="产品名称" hasFeedback>
              <a-input
                placeholder="请输入产品名称"
                autocomplete="off"
                :disabled="!isEdit"
                v-decorator="['name', { rules: [{ required: true, message: '请输入产品名称！' }] }]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="规格型号" hasFeedback>
              <a-input
                placeholder="请输入规格型号"
                autocomplete="off"
                :disabled="!isEdit"
                v-decorator="['spec', { rules: [{ required: true, message: '请输入规格型号！' }] }]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="单位" hasFeedback>
              <a-select
                :allowClear="true"
                placeholder="请选择单位"
                :disabled="!isEdit"
                v-decorator="['unit', { rules: [{ required: true, message: '请选择单位！' }] }]"
              >
                <a-select-option v-for="(option, index) in unitList" :key="index" :value="option.code">
                  {{ option.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </div>
  </zm-modal>
</template>

<script>
import { mapState } from 'vuex'
import { getDictInfoByCode } from '@/api/dict'
import { insertInquiry, updateInquiry } from '@/api/inquiry'
export default {
  name: 'editInquiry',
  computed: {
    isEdit () {
      return this.type !== this.$sysInfo.MODAL_VIEW
    },
    drawerWidth () {
      const width = window.innerWidth - 200
      return width
    },
    ...mapState({})
  },
  components: {},
  data () {
    return {
      title: '操作',
      width: 1000,
      type: 'add', //  弹窗的类型： add:新增 |modify:修改 | del:删除
      infoLoading: false, // 编辑窗口，获取详情loading
      form: this.$form.createForm(this, { name: 'inquiry' }),
      visible: false,
      defaultModel: {},
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 20 }
      },
      labelCol2: {
        xs: { span: 24 },
        sm: { span: 2 }
      },
      wrapperCol2: {
        xs: { span: 24 },
        sm: { span: 20 }
      },
      colSpan: 24,

      unitList: []
    }
  },
  methods: {
    // 设置类型
    setType (type) {
      this.type = type
    },
    // 设置标题
    setTitle (title) {
      this.title = title
    },
    // 设置model 参数 修改时传入
    setModel (model) {
      this.model = Object.assign({}, model)
    },
    // 打开or关闭，修改的窗口先获取详情
    open (flag) {
      this.formClear()
      this.visible = flag
      if (flag) {
        this.initDictData()
        if (this.type === this.$sysInfo.MODAL_MODIFY || this.type === this.$sysInfo.MODAL_VIEW) {
          this.setModelInfo()
        }
      } else {
        this.model = {}
      }
    },
    setModelInfo () {
      this.$nextTick(() => {
        this.form.setFieldsValue({
          name: this.model.name,
          spec: this.model.spec,
          unit: this.model.unit
        })
      })
    },
    // 提交表单
    handleSubmit () {
      this.form.validateFieldsAndScroll(async (err, value) => {
        if (!err) {
          const params = { ...value }
          this.$refs.modal.handleOkLoading(true)
          if (this.type === this.$sysInfo.MODAL_ADD) {
            const res = await insertInquiry(params).catch((error) => {
              this.$refs.modal.handleOkLoading(false)
              console.log('更新失败', error)
              this.$message.error('更新失败，请稍后重试！')
            })
            this.$refs.modal.handleOkLoading(false)
            if (res && res.status === 0) {
              this.$message.success(res.info.message)
              this.$emit('refreshTable')
              this.open(false)
            } else {
              this.$message.warning(res.info.message)
            }
          } else if (this.type === this.$sysInfo.MODAL_MODIFY) {
            params.id = this.model.id
            const res = await updateInquiry(params).catch((error) => {
              this.$refs.modal.handleOkLoading(false)
              console.log('更新失败', error)
              this.$message.error('更新失败，请稍后重试！')
            })
            this.$refs.modal.handleOkLoading(false)
            if (res && res.status === 0) {
              this.$message.success(res.info.message)
              this.$emit('refreshTable')
              this.open(false)
            } else {
              this.$message.warning(res.info.message)
            }
          }
        }
      })
    },
    // 清空表单
    formClear () {
      this.$nextTick(() => {
        this.form.resetFields()
      })
    },
    cancel () {
      this.formClear()
      this.open(false)
    },
    // 获取select列表
    initDictData () {
      getDictInfoByCode({ pCode: 'PRODUCT_UNIT' }).then((res) => {
        if (res.status === 0) {
          this.unitList = res.data
        }
      })
    }
  }
}
</script>

<style lang="less">
.info_label{
  margin-bottom: 10px;
}
</style>

